<div class="user-management-audit">
  <div *ngIf="usersLoading">Loading...</div>

  <ng-container *ngIf="!usersLoading">
    <mat-accordion *ngIf="users.length; else noUsers" displayMode="flat">
      <mat-expansion-panel
        *ngFor="let user of users; trackBy: userTrackByFn"
        (opened)="selectUser(user)"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>{{ user.firstName }} {{ user.lastName }}</mat-panel-title>
          <mat-panel-description>{{ user.email }}</mat-panel-description>
        </mat-expansion-panel-header>

        <ng-template matExpansionPanelContent>
          <div *ngIf="selectedUser?.id === user.id" class="user-audit-content">
            <div class="user-audit-log-toggle">
              <button
                mat-button
                [color]="activeLogView === 'user' ? 'primary' : undefined"
                (click)="showUserLogs(user)"
              >
                User Logs
              </button>
              <button
                mat-button
                [color]="activeLogView === 'role' ? 'primary' : undefined"
                (click)="showRoleLogs(user)"
              >
                Role Logs
              </button>
            </div>

            <div *ngIf="activeLogView" class="user-audit-logs">
              <div *ngIf="logsLoading">Loading...</div>

              <ng-container *ngIf="!logsLoading">
                <div *ngIf="logs.length; else noLogs">
                  <div class="audit-log" *ngFor="let log of logs; trackBy: logTrackByFn">
                    <div class="audit-log-header">
                      <strong>{{ log.action }}</strong>
                      <span>by {{ log.performedBy }} on {{ log.time | date : 'short' }}</span>
                    </div>
                    <div *ngIf="log.fields?.length" class="audit-log-fields">
                      <div class="audit-log-field" *ngFor="let field of log.fields">
                        <span class="field-name">{{ field.name }}</span>
                        <span>{{ field.oldValue }}</span>
                        <span>&rarr;</span>
                        <span>{{ field.newValue }}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <ng-template #noLogs>
                  <em class="text-warning">No audit logs were found</em>
                </ng-template>
              </ng-container>

              <sd-pagination
                *ngIf="logs.length"
                [dataSubscription]="logsPagination$"
                (paginationEvent)="onLogsPageChange($event)"
              ></sd-pagination>
            </div>
          </div>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>

    <ng-template #noUsers>
      <div class="text-center">
        <em class="text-warning">No users were found</em>
      </div>
    </ng-template>
  </ng-container>

  <footer>
    <sd-pagination
      *ngIf="users.length"
      [dataSubscription]="usersPagination$"
      (paginationEvent)="onUsersPageChange($event)"
    ></sd-pagination>
  </footer>
</div>
